module.exports = __webpack_public_path__ + "static/media/anti-scale-system.1fca45ed.jpeg";